import type {App} from 'vue';
import {WebStorageService, WebStorageServiceInterface, WebStorageServiceOptions} from '@/services/WebStorageService';

export const USER_TOKEN_STORAGE_KEY = process.env.VUE_APP_USER_TOKEN_STORAGE_KEY || 'token';
export const USER_IMPERSONATOR_TOKEN_STORAGE_KEY = 'impersonator_token'

const storage: WebStorageServiceInterface = new WebStorageService(window.localStorage, {namespace: ''});

export function useStorage(): null | WebStorageServiceInterface {

    return storage;
}

export default {
    install(app: App, options: WebStorageServiceOptions): void {

        storage.setOptions({namespace: options.namespace})

        app.provide('$storage', storage);
        app.config.globalProperties.$storage = storage;
    }
}